import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import AccountList from '../views/AccountList.vue'
import AccountListKyc from '@/modules/account/views/AccountListKYC.vue'
import AccountListBO from '@/modules/account/views/AccountListBO.vue'
import AccountBOCreate from '@/modules/account/views/AccountBOCreate.vue'
const baseRoute = OneNetworkConfig.baseRoutePath
const accountRouter = [
  {
    path: `${baseRoute}/account/list`,
    name: 'account-list',
    meta: {
      component: AccountList
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/account/kyc`,
    name: 'account-kyc',
    meta: {
      component: AccountListKyc
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/account/bo`,
    name: 'account-bo',
    meta: {
      component: AccountListBO
    },
    component: PrivateRouter,
  },

  {
    path: `${baseRoute}/account/bo/create`,
    name: 'account-bo-create',
    meta: {
      component: AccountBOCreate,
    },
    component: PrivateRouter,
  },
]

export default accountRouter
